goog.provide('el8.data.labTestVendors');

goog.require('el8.model.base');

el8.data.labTestVendors = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addStringProperty('displayName');

    _class.prototype.asSoyMap = function() {
        return {
            id: this.getId(),
            name: this.getDisplayName() || this.getName()
        };
    };

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() {
            return el8.service.urls.get('labTestVendors');
        }
    });

})();

